import React from "react";
import ReactTooltip from "react-tooltip";
import withStyles from "@material-ui/core/styles/withStyles";
import "react-toastify/dist/ReactToastify.css";
import { Box, Typography } from "@material-ui/core";
import { Help } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useStyles } from "./styles";

function ClaimStatus({ classes: { statusButton, question }, handleRemarksClick, item }) {
  console.log("ClaimStatus item:", item);
  
  return (
    <>
      <Box
        display={"flex"}
        className={`${statusButton} ${item?.status_slug}`}
        data-tip={item?.rejection_reason}
      >
        {item?.status}
        {item?.rejection_reason && (
          <>
            <Help style={{ height: "20px" }} />
            <ReactTooltip html={true} />
          </>
        )}
      </Box>

      {/* Conditionally display cancellation reason and cancelled by */}
      {item?.cancellation_reason && item?.cancelled_by && (
        <Box mt={1}>
          <Typography variant="body1" style={{ fontSize: "12px" }}>
            <strong>Cancelled By:</strong> {item.cancelled_by}
          </Typography>
          <Typography variant="body1" style={{ color: "red", fontSize: "12px" }}> {/* Color only the reason */}
            <strong>Reason:</strong> {item.cancellation_reason}
          </Typography>
          
        </Box>
      )}
      <Box
        display={"flex"}
        onClick={() => handleRemarksClick(item)}
        style={{ color: "#3c63fc" }}
      >
        <VisibilityIcon style={{ height: "20px" }} /> Remarks
      </Box>
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(ClaimStatus);
